<template>
  <div class="layout layout--map layout--facilities">
    <facilities-map></facilities-map>

    <div class="layout__item layout__item--main">
      <div class="container pdgx">
        <div class="text-limited mrgv+">
          <h1>{{ elementData.title }}</h1>
          <div class="text-h2 text-light mrgb+">{{ elementData.lead }}</div>
          <div ref="additionalLead" />
        </div>
      </div>
      <div class="teaser-list-calendar flex">
        <div class="facet-sidebar flex flex-column">
          <div class="facet-sticky">
            <button
              class="btn relative text-semi text-brand flex-important flex-center-space-between pdglx"
              @click.prevent="toggleFilter"
            >
              {{ t('FILTER') }}
              <icon
                icon-id="arrow-left"
                :classes="['icon--toggle', 'bg-brand', 'text-white']"
              ></icon>
            </button>
            <selected-list></selected-list>
            <facet-bar></facet-bar>
            <facet-list></facet-list>
          </div>
        </div>
        <div class="bg-alt relative flex-1">
          <results :is-small="true" :no-text="true"></results>
          <overlay></overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Results from '@/components/Results'
import FacilitiesMap from '@/components/Facilities/Map'

import Overlay from '@/components/Overlay'

import FacetBar from '@/components/Facets/Bar'
import FacetList from '@/components/Facets/List'
import SelectedList from '@/components/Selected/List'
import Icon from '@/components/Ui/Icon'

import { APP_CONFIG } from '@/settings'

export default {
  components: {
    Results,
    FacilitiesMap,
    FacetBar,
    FacetList,
    SelectedList,
    Overlay,
    Icon
  },

  props: {
    elementData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  mounted() {
    const additional = document.querySelector('#vue-app-lead')

    if (additional) {
      this.$refs.additionalLead.appendChild(additional)
      additional.style.display = ''
    }
    this.$store.dispatch('setConfig', APP_CONFIG.FACILITIES)
    this.$store.dispatch('Results/load', {
      initQueryString: true
    })
  },

  methods: {
    toggleFilter() {
      const body = document.body
      const className = ' filter-sidebar-closed'

      if (
        body.hasAttribute('class') &&
        body.getAttribute('class').search(className) !== -1
      ) {
        body.setAttribute(
          'class',
          body.getAttribute('class').replace(className, '')
        )
      } else {
        body.setAttribute(
          'class',
          (
            (body.hasAttribute('class') ? body.getAttribute('class') : '') +
            className
          ).trim()
        )
      }
    }
  }
}
</script>
